import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { ArrowDown } from '@yme/assets/icons';
import { ExpandingBlock } from '@yme/atoms/expanding-block';
import { GridWrapper } from '@yme/atoms/grid';
import { getRTL } from '@yme/selectors/common';
import { getIsLoadedProductDetails } from '@yme/selectors/products';
import { colorWhiteTransparent800 } from '@yme/tokens/colors';
import { ProductDisclaimerSkeleton } from './ProductDisclaimerSkeleton';
import { getProductDisclaimerValue } from './selectors';
import { ProductDisclaimerStyled, Label, Text, ContainerWrapper } from './styled';
export function ProductDisclaimer({ labels, isInEditor, }) {
    const productDisclaimerValue = useSelector(getProductDisclaimerValue);
    const isRightToLeft = useSelector(getRTL);
    const isLoadedProductDetails = useSelector(getIsLoadedProductDetails);
    const blockHolderRef = useRef(null);
    const { productDisclaimer_disclaimer_label: disclaimerLabel } = labels;
    if (!isLoadedProductDetails && !isInEditor) {
        return React.createElement(ProductDisclaimerSkeleton, null);
    }
    if (!productDisclaimerValue) {
        return null;
    }
    return (React.createElement(ContainerWrapper, null,
        React.createElement(GridWrapper, null,
            React.createElement(ProductDisclaimerStyled, { ref: blockHolderRef },
                React.createElement(ExpandingBlock, { iconType: ArrowDown, isRightToLeft: isRightToLeft, textColor: colorWhiteTransparent800 },
                    React.createElement(Label, { isRightToLeft: isRightToLeft, textColor: colorWhiteTransparent800 }, `${disclaimerLabel}:`),
                    React.createElement(Text, { isRightToLeft: isRightToLeft, textColor: colorWhiteTransparent800 }, productDisclaimerValue))))));
}
ProductDisclaimer.displayName = 'ProductDisclaimer_AEMComponent';
